<h1 *ngIf="canManageProjects" mat-dialog-title>{{projectName ? ('project.EditProject' | translate:projectName) : ('project.NewProject' | translate)}}</h1>
<div mat-dialog-content>
  <app-project-editor #projectEditor [project]="data.project" ></app-project-editor>
</div>
<div mat-dialog-actions>
  <button *ngIf="canManageProjects" mat-raised-button (click)="projectEditor.save();"  [disabled]="!projectEditor.form.dirty" color="primary"> {{'common.Save' | translate}}</button>
  <button *ngIf="canManageProjects" mat-raised-button (click)="cancel()" color="warn"> {{'common.Cancel' | translate}}</button>
</div>
